module.exports = __webpack_public_path__ + "static/img/pdf-on-64px.02547f81.png";